import { render, staticRenderFns } from "./MainContentSettings.vue?vue&type=template&id=7387fca8&scoped=true&lang=pug"
import script from "./MainContentSettings.vue?vue&type=script&lang=js"
export * from "./MainContentSettings.vue?vue&type=script&lang=js"
import style0 from "./MainContentSettings.vue?vue&type=style&index=0&id=7387fca8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7387fca8",
  null
  
)

export default component.exports